/**
 * @desc 健康度材料查看
 */
import React from "react";
import { connect } from 'dva';
import { Descriptions } from 'antd';
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { Row, Col } from 'antd';
import moment from "moment";

let { WizContainer, modelUtils, WizAvatarUpload, ossFileUtils } = framework_tool
let { WizCard, WizSelect, WizForm, Wizmessage, WizRow, WizCol, WizInput, WizSpin,WizModal,WizBraftEditor } = component_tool
let { Session } = utils_tool

class LookDealerAppeal extends WizContainer {
  componentName = 'lookDealerAppeal'

  constructor(props) {
    super(props)
    const { history } = props
    let detailInfo = {};
    if (history.location && history.location.pathname === '/org/dealerAppeal/lookDealerAppeal') {
      if (history.location && history.location.record) {
        detailInfo = history.location.record
        Session.set('dealerAppealInfo', detailInfo)
      } else {
        detailInfo = Session.get('dealerAppealInfo') || {}
      }
    }
    this.state = {
      time: undefined,
      previewImgVisible: false,
      previewImgKey: new Date().getTime(),
      previewImage: '',
    }
    this.detailInfo = detailInfo
  }

  _componentDidMount() {
    if (this.detailInfo.id) {
      this.doAction({
        path: 'dealerAppeal/getInfoById',
        payload: {
          key: "dealerAppeal@getInfoById",
          apiParams: {
            id: this.detailInfo.id
          }
        }
      });
    }
  }

  propsAndStateOnChange = {
    dealerAppealInfo: this._getDealerAppealInfoOver.bind(this)
  }

  _getDealerAppealInfoOver(nextProps, nextState) {
    if (nextProps.dealerAppealInfo.code == 1) {
      this.detailInfo = nextProps.dealerAppealInfo.data;
      nextState.time = new Date().getTime();
    } 
    return true;
  }

  /** 打开图片查看*/
  handlePreview = async element => {
    this.setState({
      previewImage: element,
      previewImgVisible: true,
      previewImgKey: new Date().getTime(),
    });
  };

  /** 关闭查看Model*/
  handleCancel = () => this.setState({
    previewImgVisible: false
  });

  getImgInfo = (type) => {
    let {invoiceImgsUrl,displaceImgsUrl,mortgageImgsUrl,otherImgsUrl,videosUrl,damagedFilesUrl,testDriveFilesUrl,blocFilesUrl,subsidyFilesUrl,vipFilesUrl} = this.detailInfo
    let datas = '';
    if(type==='invoiceImgsUrl'){
      datas = invoiceImgsUrl
    }else if(type==='displaceImgsUrl'){
      datas = displaceImgsUrl
    }else if(type==='mortgageImgsUrl'){
      datas = mortgageImgsUrl
    }else if(type==='otherImgsUrl'){
      datas = otherImgsUrl
    }else if(type==='videosUrl'){
      datas = videosUrl
    }else if(type==='damagedFilesUrl'){
      datas = damagedFilesUrl
    }else if(type==='testDriveFilesUrl'){
      datas = testDriveFilesUrl
    }else if(type==='blocFilesUrl'){
      datas = blocFilesUrl
    }else if(type==='subsidyFilesUrl'){
      datas = subsidyFilesUrl
    }else if(type==='vipFilesUrl'){
      datas = vipFilesUrl
    }


    let urls = [];
    if(datas && datas.indexOf(';')!==-1){
      urls = datas.split(";");
    }else if(datas && datas.length){
      urls.push(datas);
    }
    let show = []
    if(type==='videosUrl'){
      for(let i=1;i<=urls.length;i++){
        let e = urls[i-1];
        show.push( <Col span={24} ><div height={80} width={130} style={{margin:5}} >
          <a href={e} target="_blank" style={{color: "blue"}}>质损视频附件{i}</a>
          </div></Col>)
      }
    }else{
      urls.forEach(e=>{
        show.push( <Col span={4.5} ><img height={80} width={130} style={{margin:5, objectFit: 'cover' }} src={e} onClick={p => this.handlePreview(e)}/></Col>)
      })
    }
   
    return (
      <Row type='flex' justify = 'start' gutter={{ xs: 4.5, sm: 16, md: 24}}>
        {show}
      </Row>
    )
    
  }

  reRecord=(e)=>{
    // let dict = [
    //   { code: 1, codeName: 'GL8 ES 653T 舒适型 23' },
    //   { code: 2, codeName: 'GL8 ES 653T 尊享型 23' },
    //   { code: 3, codeName: 'GL8 ES 653T 豪华型(谦和米) 23' },

    //   { code: 4, codeName: 'GL8 陆尊插混 智享版 25.5' },
    //   { code: 5, codeName: 'GL8 陆尊插混 尊享版 25.5' },
    //   { code: 6, codeName: 'GL8 陆尊插混 七座奢享版(玄武月白内饰) 25.5' },
    //   { code: 7, codeName: 'GL8 陆尊插混 七座奢享版(黛蓝月白内饰) 25.5' },
    //   { code: 8, codeName: 'GL8 陆尊插混 六座奢享版(黛蓝月白内饰) 25.5' },

    //   { code: 9, codeName: 'GL8 Avenir艾维亚 六座贤礼版(Sangria) 23' },

    //   { code: 10, codeName: 'GL8 652T 舒适型 24' },
    //   { code: 11, codeName: 'GL8 652T 智享型 24' },
    //   { code: 12, codeName: 'GL8 652T 豪华型(谦和米) 24' },
    //   { code: 13, codeName: 'GL8 652T 尊贵型(谦和米) 24' },
    //   { code: 14, codeName: 'GL8 652T 智慧尊贵型 24' },
    //   { code: 15, codeName: 'GL8 豪华型-专供版 24' },
    //   { code: 16, codeName: 'GL8 智享型-专供版 24' },

    //   { code: 17, codeName: '昂科威Plus 28T 豪华型 24' },
    //   { code: 18, codeName: '昂科威Plus 28T 尊享版(页岩黑) 24' },
    //   { code: 19, codeName: '昂科威Plus 28T 尊享版(丹霞红) 24' },
    //   { code: 20, codeName: '昂科威Plus 28T 四驱尊享版 24' },
    //   { code: 21, codeName: '昂科威Plus 艾维亚 24.5' },

    //   { code: 22, codeName: '世纪CENTURY 七座臻享款 23' },
    //   { code: 23, codeName: '世纪CENTURY 七座蕴世版(红黑内饰-赤霞红座椅) 23' },
    //   { code: 24, codeName: '世纪CENTURY 七座蕴世版(蓝白内饰-云峰白座椅) 23' },
    //   { code: 25, codeName: '世纪CENTURY 六座蕴世版(红黑内饰-赤霞红座椅) 23' },
    //   { code: 26, codeName: '世纪CENTURY 六座蕴世版(蓝白内饰-云峰白座椅) 23' },
    //   { code: 27, codeName: '世纪CENTURY 四座私享版(青白内饰-冷杉青座椅) 23' },
    //   { code: 28, codeName: '世纪CENTURY 四座私享版(青白内饰-云峰白座椅) 23' },
    //   { code: 29, codeName: '世纪CENTURY 四座私享版-关山飞雪双色车身(青白内饰-冷杉青座椅) 23' },
    //   { code: 30, codeName: '世纪CENTURY 四座私享版-关山飞雪双色车身(青白内饰-云峰白座椅) 23' }
    // ]

    let dictAddType = [
      { code: 1, codeName: '奔驰' },
      { code: 2, codeName: '宝马' },
      { code: 3, codeName: '奥迪' },
      { code: 4, codeName: '凯迪拉克' },
      { code: 5, codeName: '雪佛兰' },
      { code: 6, codeName: '别克' }
    ]

    e.isDisplace == 0 ? e.isDisplaceStr = '否' : e.isDisplaceStr = '是'
    e.displaceType == 1 ? e.displaceType = '本品置换' : e.displaceType == 2 ? e.displaceType ='竞品置换':''
    e.isAdd == 0 ? e.isAddStr = '否' : e.isAddStr ='是'
    e.invoiceTime = e.invoiceTime ? moment(e.invoiceTime).format('YYYY-MM-DD') : '';
    e.isMortgage == 0 ? e.isMortgageStr = '否' : e.isMortgageStr ='是'

    e.isDamaged == 0 ? e.isDamagedStr = '否' : e.isDamagedStr = '是'
    e.isTestDrive == 0 ? e.isTestDriveStr = '否' : e.isTestDriveStr = '是'
    e.isBloc == 0 ? e.isBlocStr = '否' : e.isBlocStr = '是'
    e.isSubsidy == 0 ? e.isSubsidyStr = '否' : e.isSubsidyStr = '是'
    e.isVip == 0 ? e.isVipStr = '否' : e.isVipStr = '是'
    e.isAging == 0 ? e.isAgingStr = '否' : e.isAgingStr = '是'
    e.subsidyWay == 1 ? e.subsidyWayStr = '个人' : e.subsidyWayStr = '经销商代办'
    e.isAllowSubmit == 0 ? e.isAllowSubmitStr = '否' : e.isAllowSubmitStr = '是'
    // dict.forEach(element=>{
    //   if(e.vehicleModelId==element.code){
    //     e.vehicleModelId = element.codeName
    //   }
    // })
    dictAddType.forEach(element=>{
      if(e.addType==element.code){
        e.addType = element.codeName
      }
    })
    return e
  }

  _render() {
    const detailInfo = this.detailInfo
    let record = this.reRecord(detailInfo);
    return (
      <React.Fragment>
        <WizSpin tip={'加载中'} spinning={this.props.dealerAppealLoading}>
          <WizCard>
            <Descriptions column={1}  bordered={true} >
              <Descriptions.Item label='品牌'>{record.brandName}</Descriptions.Item>
              <Descriptions.Item label='区域'>{record.areaName}</Descriptions.Item>
              <Descriptions.Item label='门店代码'>{record.dealerCode}</Descriptions.Item>
              <Descriptions.Item label='门店名称'>{record.dealerName}</Descriptions.Item>
              <Descriptions.Item label='发出者'>{record.sender}</Descriptions.Item>
              <Descriptions.Item label='发出者手机号'>{record.senderMobile}</Descriptions.Item>
              <Descriptions.Item label='发出者邮箱'>{record.senderMail}</Descriptions.Item>
              <Descriptions.Item label='发出日期'>{record.senderTime}</Descriptions.Item>
              <Descriptions.Item label='车型'>{record.vehicleModelName}</Descriptions.Item>
              <Descriptions.Item label='车架号'>{record.vehicleIdentifyNum}</Descriptions.Item>
              <Descriptions.Item label='发票金额(元)'>{record.invoiceValue}</Descriptions.Item>
              <Descriptions.Item label='发票日期'>{record.invoiceTime}</Descriptions.Item>
              <Descriptions.Item label='手机号'>{record.mobile}</Descriptions.Item>
              <Descriptions.Item label='邮箱'>{record.mail}</Descriptions.Item>
              <Descriptions.Item label='是否置换'>{record.isDisplaceStr}</Descriptions.Item>
              {record.isDisplace == 1 ? <Descriptions.Item label='置换类型'>{record.displaceType}</Descriptions.Item> : null}
              <Descriptions.Item label='是否增购'>{record.isAddStr}</Descriptions.Item>
              {record.isAdd == 1 ? <Descriptions.Item label='增购类型'>{record.addType}</Descriptions.Item> : null}
              <Descriptions.Item label='是否按揭'>{record.isMortgageStr}</Descriptions.Item>
              {record.isMortgage ==1 ? <Descriptions.Item label='按揭金额(元)'>{record.mortgageValue}</Descriptions.Item> : null}
              <Descriptions.Item label='情况说明'>{record.explanation}</Descriptions.Item>

              <Descriptions.Item label='是否质损车'>{record.isDamagedStr}</Descriptions.Item>
              <Descriptions.Item label='是否试乘试驾车'>{record.isTestDriveStr}</Descriptions.Item>
              <Descriptions.Item label='是否集团客户'>{record.isBlocStr}</Descriptions.Item>
              <Descriptions.Item label='是否享受政府补贴'>{record.isSubsidyStr}</Descriptions.Item>
              {record.isSubsidy == 1 ? <Descriptions.Item label='政策名称'>{record.subsidyInfo}</Descriptions.Item>: null}
              {record.isSubsidy == 1 ? <Descriptions.Item label='补贴金额'>{record.subsidyValue}</Descriptions.Item>: null}
              {record.isSubsidy == 1 ? <Descriptions.Item label='补贴申领方式'>{record.subsidyWayStr}</Descriptions.Item>: null}
              <Descriptions.Item label='是否VIP购车'>{record.isVipStr}</Descriptions.Item>
              <Descriptions.Item label='是否高库龄'>{record.isAgingStr}</Descriptions.Item>
              <Descriptions.Item label='是否可再次提交'>{record.isAllowSubmitStr}</Descriptions.Item>
              <Descriptions.Item label='第几次提交'>{record.submitNum}</Descriptions.Item>

              <Descriptions.Item label='发票附件'>{this.getImgInfo('invoiceImgsUrl')}</Descriptions.Item>
              {record.isDisplace == 1 ? <Descriptions.Item label='置换附件'>{this.getImgInfo('displaceImgsUrl')}</Descriptions.Item>: null}
              {record.isMortgage == 1 ? <Descriptions.Item label='贷款附件'>{this.getImgInfo('mortgageImgsUrl')}</Descriptions.Item> : null}
              <Descriptions.Item label='其他附件'>{this.getImgInfo('otherImgsUrl')}</Descriptions.Item>
              <Descriptions.Item label='质损视频附件'>{this.getImgInfo('videosUrl')}</Descriptions.Item>
              
              {record.isDamaged == 1 ? <Descriptions.Item label='质损车附件'>{this.getImgInfo('damagedFilesUrl')}</Descriptions.Item>: null}
              {record.isTestDrive == 1 ? <Descriptions.Item label='试乘试驾附件'>{this.getImgInfo('testDriveFilesUrl')}</Descriptions.Item>: null}
              {record.isBloc == 1 ? <Descriptions.Item label='集团客户附件'>{this.getImgInfo('blocFilesUrl')}</Descriptions.Item>: null}
              {record.isSubsidy == 1 ? <Descriptions.Item label='补贴附件'>{this.getImgInfo('subsidyFilesUrl')}</Descriptions.Item>: null}
              {record.isVip == 1 ? <Descriptions.Item label='VIP购车附件'>{this.getImgInfo('vipFilesUrl')}</Descriptions.Item>: null}
            </Descriptions>
            <WizModal key={'img_preview_' + this.state.previewImgKey} visible={this.state.previewImgVisible} footer={null}
                    onCancel={this.handleCancel}>
            <img alt="example" style={{width: '100%'}} src={this.state.previewImage}/>
          </WizModal>
          </WizCard>
        </WizSpin>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { dealerAppeal } = state;
  const dealerAppealInfo = modelUtils.getModelEntity(dealerAppeal, "dealerAppeal@getInfoById");
  const load = modelUtils.getLoadingState(state, ['dealerAppeal']);
  return {
    dealerAppealInfo,
    ...load
  }
};

export default connect(mapStateToProps)(LookDealerAppeal)

